"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _de = _interopRequireDefault(require("../../../locals/de.json"));

var _en = _interopRequireDefault(require("../../../locals/en.json"));

var _it = _interopRequireDefault(require("../../../locals/it.json"));

var _Buttons = _interopRequireDefault(require("./Buttons.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Buttons = function Buttons(_ref) {
  var labelCheckout = _ref.labelCheckout,
      lang = _ref.lang,
      _ref$showShopButton = _ref.showShopButton,
      showShopButton = _ref$showShopButton === void 0 ? true : _ref$showShopButton,
      onCheckoutClick = _ref.onCheckoutClick,
      onShopClick = _ref.onShopClick;
  var css = (0, _Buttons.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.buttons, "mco-shop-cart-buttons")
  }, showShopButton && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _clsx.default)(css.button, css.shopButton),
    color: "primary",
    variant: "outlined",
    onClick: function onClick() {
      if (onShopClick) onShopClick();
    }
  }, l("reactShop.cart.buttons.shop")), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _clsx.default)(css.button, css.checkoutButton),
    color: "primary",
    variant: "contained",
    onClick: function onClick() {
      if (onCheckoutClick) onCheckoutClick();
    }
  }, labelCheckout ? labelCheckout : l("reactShop.cart.buttons.checkout")));
};

var _default = Buttons;
exports.default = _default;